import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, } from 'react-router-dom';
import axios from "axios";
import { Toast } from 'primereact/toast'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Api } from '../../../services/api';
import './Leads.css'
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { CommonService } from '../../../services/commonService';
import LeadModel from './LeadModel';
import { Dropdown } from 'primereact/dropdown';
import { FaFileExcel, FaTrash } from 'react-icons/fa';
import { BiPlusMedical } from 'react-icons/bi';

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Tag } from 'primereact/tag';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Editor } from 'primereact/editor';
import { MultiSelect } from 'primereact/multiselect';

const Leads = () => {
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [sortField, setSortField] = useState('contact_date');
  const [sortOrder, setSortOrder] = useState(-1);

  const [globalFilter, setGlobalFilter] = useState('');

  const [isFormSubmitLoadder, setIsFormSubmitLoadder] = useState(false);


  //* ----------------------
  const navigate = useNavigate();
  const [selectedProduct, setSelectedProduct] = useState(null);

  const edit = (event) => {

    var params = {
      start: first,
      length: rows,
      search: selectedColumnField == 'new_status' ? null : selectedColumnValue,
      order: sortField,

      orderDir: sortOrder === 1 ? 'ASC' : 'DESC',

      status: selectedColumnStatusValue,
      field: selectedColumnField,
    };

    localStorage.setItem('paramsetlead', JSON.stringify(params));
    localStorage.setItem('leadRedirect', true);
    localStorage.setItem('selectedProduct', JSON.stringify(event));

    localStorage.setItem('selectedColumnField', selectedColumnField);
    localStorage.setItem('selectedColumnValue', selectedColumnValue);
    localStorage.setItem('selectedColumnStatusValue', selectedColumnStatusValue);
    navigate('/lead-edit/' + event._id)
  }

  const onRowSelect = (e) => {
    const rowData = e.data;
    edit(rowData);
  };

  const onRowUnselect = (event) => {
    const rowData = event.data;
    edit(rowData);
  };

  const addLeads = () => {
    navigate('/lead-add/')
  }
  //! ----------------------

  const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] =
    useState(false);
  const [projectDeletetitle, setProjectDeleteTitle] = useState('Are you sure you want to delete this lead?');
  const [isLoading, setIsLoading] = useState(true);
  const [leads, setLeads] = useState([]);
  const [leadYear, setLeadYear] = useState('2024');
  const toast = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [type, setType] = useState('Add');

  const [leadsId, setLeadsId] = useState(null);
  const [editLeadList, seteEditLeadList] = useState([]);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    client: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    address: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    project_type: { value: null, matchMode: FilterMatchMode.EQUALS },
  });

  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(20);
  const [colorPlatedailog, setColorPlatedailog] = useState(false);


  const [projectTypeList, setProjectTypeList] = useState([]);

  //TODO ------------------------
  const [selectedColumnField, setSelectedColumnField] = useState('contact_date');
  const [selectedColumnValue, setSelectedColumnValue] = useState('');
  const [selectedColumnStatusValue, setSelectedColumnStatusValue] = useState('All');

  //TODO ------------------------

  //?------------------------
  const [allSupervisors, setAllSupervisors] = useState([]);
  const [selectedCCList, setSelectedCCList] = useState([]);
  const [showId, setShowId] = useState('');
  const [showName, setShowName] = useState('');
  const [emailPopUp, setEmailPopUp] = useState(false);
  const [customSubject, setCustomSubject] = useState('');
  const [customMessage, setCustomMessage] = useState('');
  //!------------------------

  useEffect(() => {

    var leadRedirect = localStorage.getItem('leadRedirect')
    console.log('leadRedirect', leadRedirect);
    if (leadRedirect) {

      setSelectedColumnField(localStorage.getItem('selectedColumnField'));
      setSelectedColumnValue(localStorage.getItem('selectedColumnValue'));
      setSelectedColumnStatusValue(localStorage.getItem('selectedColumnStatusValue'));

      fetchDataGoBack();
    } else {

      localStorage.setItem('selectedColumnStatusValue', 'All');

      setSelectedColumnField('contact_date');
      setSelectedColumnValue('');
      setSelectedColumnStatusValue('All');
      getListData();
    }
    getListDataLeads();
    getUser();

    return () => {
    };
  }, [leadYear]);

  const fetchDataGoBack = async () => {
    //  localStorage.removeItem('leadRedirect');
    var paramsetlead = JSON.parse(localStorage.getItem('paramsetlead'))
    var selectedProductForList = JSON.parse(localStorage.getItem('selectedProduct'))
  
    setSelectedProduct(selectedProductForList)

    setFirst(paramsetlead.start);
    setRows(paramsetlead.length);
    setSortField(paramsetlead.order);
    setSortOrder(paramsetlead.orderDir == 'ASC' ? 1 : -1);

    /** select column selected start  */
    var params = {
      start: paramsetlead.start,
      length: paramsetlead.length,
      search: paramsetlead.field == 'new_status' ? null : paramsetlead.search,      
      order: paramsetlead.order,
      orderDir: paramsetlead.orderDir,
      year: paramsetlead.year,
      status: paramsetlead.status,
      field: paramsetlead.field,
    };

    var url = Api.API_BASE_URL + 'leads-tracker/all-leads-server-side'; //leads-datatable-server-side';

    try {
      const token = localStorage.getItem('authToken');

      // Create headers with token if it exists
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
      };
      console.log('API Call 1', params);
      const response = await axios.get(url, { params: params, headers: headers });
      setIsLoading(false);
      setLeads(response.data.data);
      setTotalRecords(response.data.totalRecords);
      localStorage.removeItem('leadRedirect');
      localStorage.removeItem('paramsetlead');


      localStorage.removeItem('selectedColumnField');
      localStorage.removeItem('selectedColumnValue');
      localStorage.removeItem('selectedColumnStatusValue');
      // localStorage.removeItem('selectedProduct');
      // setSelectedProduct(null); // avoids selecting stale or mismatched data
    } catch (error) {
      console.error('Error fetching data sadfsdf', error);
    }
    setIsLoading(false);
  };

  const getListData = async () => {
    //localStorage.removeItem('selectedProduct');
    setIsLoading(true);
    var _body = {
      year: leadYear,
      // year: leadYear,
    }
    const token = localStorage.getItem('authToken')
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
    fetch(Api.API_BASE_URL + 'crm/get-leads', {
      method: "POST",
      body: JSON.stringify(_body),
      headers: headers,
    })
      .then((response) => response.json())
      .then((response) => {
        setLeads(response.result);

        setIsLoading(false);
        setTotalRecords(response.totalRecords);

      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error:", error);
      });

  }

  const getListDataLeads = async () => {
    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };

    axios.get(Api.API_BASE_URL + 'crm/get-dropdown-list', {
      headers
    })
      .then((response) => {

        setProjectTypeList(response.data.project_type);

      })
      .catch((error) => {
        console.error('Error fetching projects:', error);
      });
  }


  const getUser = async () => {
    try {
      const token = localStorage.getItem('authToken');

      // Create headers with token if it exists
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
      };
      const response = await axios.get(Api.API_BASE_URL + 'get-all-users', { headers: headers });

      setAllSupervisors(response.data.result);

      // setSupervisor_id([...response.data.supervisor_id]);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching users:', error);
      setIsLoading(false);
    }
  };



  const handleDeleteProject = (rowData) => {
    setLeadsId(rowData);
    setIsDeleteConfirmationModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsDeleteConfirmationModalOpen(false);
  };

  const afterDelete = async () => {

    var params = {
      start: 0,
      length: rows,
      order: sortField,
      orderDir: sortOrder === 1 ? 'ASC' : 'DESC',
      status: selectedColumnStatusValue,
      field: 'client',
    };

    var url = Api.API_BASE_URL + 'leads-tracker/all-leads-server-side'; //leads-datatable-server-side';

    try {
      const token = localStorage.getItem('authToken');

      // Create headers with token if it exists
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
      };
      console.log('API Call 2', params);
      const response = await axios.get(url, { params: params, headers: headers });
      setLeads(response.data.data);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      console.error('Error fetching data', error);
    }

    setLoading(false);

  };

  const confirmDelete = async () => {
    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
    var baseUrl = Api.API_BASE_URL + 'crm/delete-lead/' + leadsId
    axios.get(baseUrl, { headers })
      .then((response) => {
        toast.current.show({ severity: 'success', detail: response.data.result, life: 3000 });
        afterDelete();
        closeModal();
      })
      .catch((error) => {
        console.error('Error fetching projects:', error);
      });
  }


  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>

        <div onClick={(e) => e.stopPropagation()}>
          <FaTrash title='Delete leads' onClick={() => handleDeleteProject(rowData._id)} style={{ color: 'darkred', marginRight: '15px' }} />
        </div>
      </React.Fragment>
    );
  };



  const dateView = (date) => {
    if (date == null || date == '' || date == '0000-00-00' || date == '0000-00-00 00:00:00') {
      return '';
    }

    // const parsedDate = new Date(date);
    // const year = parsedDate.getFullYear();
    // const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    // const day = parsedDate.getDate().toString().padStart(2, '0');

    // const newFormattedDate = `${year}-${month}-${day}`;

    // return newFormattedDate;

    return date.toString().substring(0,10);
  }



  const exportExcel = async () => {
    try {
      const token = localStorage.getItem('authToken');

      // Create headers with token if it exists
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
      };
      fetch(Api.API_BASE_URL + 'leads-tracker/leads-download', {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ status: selectedColumnStatusValue, year: leadYear }),
      })
        .then((response) => response.json())
        .then(async (response) => {
          var apiLeads = response.result;

          const workbook = new ExcelJS.Workbook();
          const worksheet = workbook.addWorksheet('Leads');

          // Add columns with headers
          worksheet.columns = [
            // { header: 'id', key: 'id', width: 20 },
            { header: 'YEAR', key: 'year', width: 20 },
            { header: 'CLIENT', key: 'client', width: 20 },
            { header: 'ADDRESS', key: 'address', width: 20 },
            { header: 'EMAIL', key: 'email', width: 20 },
            { header: 'PHONE NUMBER', key: 'phone_number', width: 20 },
            { header: 'LEAD SOURCE', key: 'lead_source', width: 20 },
            { header: 'PROJECT TYPE', key: 'project_type', width: 20 },
            { header: 'PROJECT VALUE', key: 'project_value', width: 20 },
            { header: 'CONTACT DATE', key: 'contact_date', width: 20 },
            { header: 'DECLINED TYPE', key: 'declined_type', width: 20 },
            { header: 'SITE VISIT DATE', key: 'site_visit_date', width: 20 },
            { header: 'SITE VISIT STAGE', key: 'site_visit_stage', width: 20 },
            { header: 'CONTACT TO SITE VISIT DAYS', key: 'contact_to_site_visit_days', width: 20 },
            { header: 'CE SENT OUT', key: 'ce_sent_out', width: 20 },
            { header: 'CE STAGE', key: 'ce_stage', width: 20 },
            { header: 'SITE VISIT TI CE DAYS', key: 'site_visit_to_ce_days', width: 20 },
            { header: 'FSA DATE', key: 'fsa_date', width: 20 },
            { header: 'FSA STAGE', key: 'fsa_stage', width: 20 },
            { header: 'CE TO FSA DAYS', key: 'ce_to_fsa_days', width: 20 },
            { header: 'CONTRACT DATE', key: 'contract_date', width: 20 },
            { header: 'CONTRACT STAGE', key: 'contract_stage', width: 20 },
            { header: 'FSA TO CONTRACT DAYS', key: 'fsa_to_contract_days', width: 20 },
            { header: 'CONSTRUCTION START DATE', key: 'adconstruction_start_datedress', width: 20 },
            { header: 'CONSTRUCTION START STAGE', key: 'construction_start_stage', width: 20 },
            { header: 'CONSTRUCTION TO START DAYS', key: 'construction_to_start_days', width: 20 },
            { header: 'COMPLETION TO CONSTRUCTION DAYS', key: 'completion_to_construction_days', width: 20 },
            { header: 'CLIENT INFORMATION', key: 'cilentInformation', width: 20 },
            { header: 'NOTES', key: 'notes', width: 20 },
            { header: 'SR PM NOTES', key: 'sr_pm_notes', width: 20 },
            { header: 'VP OF CONSTRUCTION COMMENTS', key: 'vp_of_construction_comments', width: 20 },
            { header: 'STATUS', key: 'status', width: 20 },

            { header: 'LEAD STATUS', key: 'lead_status', width: 20 },
            { header: 'STREET NUMBER', key: 'street_number', width: 20 },
            { header: 'STREET NAME', key: 'street_name', width: 20 },
            { header: 'LEADS FORM', key: 'leadsform', width: 20 },
            { header: 'CITY', key: 'city', width: 20 },
            { header: 'POSTAL CODE', key: 'postal_code', width: 20 },
            { header: 'OLD ADDRESS', key: 'old_address', width: 20 },
            { header: 'FIRST NAME', key: 'first_name', width: 20 },
            { header: 'LAST NAME', key: 'last_name', width: 20 },
            { header: 'PROJECT DEC', key: 'project_desc', width: 20 },
            { header: 'WHO REFERRED YOU', key: 'who_referred_you', width: 20 },
            // Add more columns as needed

          ];

          // Add rows from leads array based on selectedColumnStatusValue
          apiLeads.forEach((lead) => {
            worksheet.addRow(lead);
          });

          // Apply styling to headers
          worksheet.getRow(1).eachCell((cell) => {
            cell.font = { name: 'Arial', size: 12, bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'fec025' }, // Red background
            };
          });

          // Apply currency formatting to the 'Value' column
          worksheet.getColumn('project_value').eachCell((cell, rowNumber) => {
            if (rowNumber > 1) { // Skip the header row
              cell.numFmt = '"$"#,##0.00';
            }
          });

          // Convert the workbook to a buffer
          const buffer = await workbook.xlsx.writeBuffer();

          // Save the buffer as an Excel file
          saveAs(
            new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
            `leads_${leadYear}_export_${new Date().getTime()}.xlsx`
          );

        })

    } catch (error) {
      console.error(error);
    }
  };

  // ________________________________________

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
  };


  const ccDropdowng = () => {
    return (
      <MultiSelect value={selectedCCList} onChange={(e) => {

        setSelectedCCList(e.value)

        console.log(selectedCCList)


        // formik.setFieldValue('cc_users', e.value[0].user_id)
      }} options={allSupervisors} optionLabel={(e) => { return e.first_name + ' ' + e.last_name + ' - ' + e.role_name }} display="chip" filter
        placeholder="Select CC" className="p-2 w-full mutiii" />
    );
  };



  const emailBodyTemplate = (rowData) => {
    const handleEmailClick = () => {
      setShowName(rowData.client)
      setShowId(rowData._id)
      // console.log('>>',rowData.client)
      // window.location.href = `mailto:${rowData.email}`;
      setCustomSubject(''); // Reset the subject
      setCustomMessage(''); // Reset the message
      setSelectedCCList([]);
      setEmailPopUp(true); // Open the dialog
    };

    return (
      <div onClick={(e) => e.stopPropagation()} className="flex justify-content-between align-items-center">
        <div className="flex">
          {rowData.email}
        </div>
        <div className="flex mr-4 ">
          <Button
            icon="pi pi-envelope"
            title={rowData.email}
            rounded
            severity="success"
            aria-label="Search"
            onClick={handleEmailClick}
          />
        </div>
      </div>
    );
  };

  const handleSaveSubmit = async (e) => {
    e.preventDefault();

    // Here you can implement the logic to send the email
    // For example, you can call an API to send the email with the custom message
    console.log('Sending email to:', showId);
    console.log('Sending email to:', showName);
    console.log('Subject:', customSubject);
    console.log('Message:', customMessage);
    console.log('cc:', selectedCCList);

    const emailData = {
      id: showId,
      to: showName,
      subject: customSubject,
      message: customMessage,
      cc: selectedCCList.map(user => user.user_id) // Assuming user_id is the identifier for CC users
    };

    try {
      const token = localStorage.getItem('authToken');
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
      };

      const response = await axios.post(Api.API_BASE_URL + 'crm/send-lead-mail', emailData, { headers });
      toast.current.show({ severity: 'success', detail: response.data.message, life: 3000 });
      // if (response.data.success) {
      //     toast.current.show({ severity: 'success', detail: 'Email sent successfully!', life: 3000 });
      // } else {
      //     toast.current.show({ severity: 'error', detail: 'Failed to send email.', life: 3000 });
      // }
    } catch (error) {
      console.error('Error sending email:', error);
      toast.current.show({ severity: 'error', detail: 'An error occurred while sending the email.', life: 3000 });
    }

    // Reset state variables after sending the email
    setShowName(''); // Reset the client name
    setCustomSubject(''); // Reset the subject
    setCustomMessage(''); // Reset the message
    setSelectedCCList([]); // Reset the CC list

    // After sending the email, you can close the dialog
    setEmailPopUp(false);
  };

  const statusItemTemplate = (option) => {
    // return <Tag value={option} className='p-2' severity={getSeverity(option)} />;
    return <Tag value={option} className='p-2' style={{ backgroundColor: getSeverity(option), color: 'white' }} />
  };

  const projectTypeAssignee = (value) => {
    if (!value || value === null) {
      return '';
    }
    return `${value.first_name} ${value.last_name}`;
  }

  const projectTypeBodyTemplateA = (value) => {
    if (!value || value === null) {
      return '';
    } else {
      var status = value;
      if (value == 'NOT PROCEEDING') {
        status = 'Not Proceeding To Fsa';
      }
      else if (value == 'NOT PROCEEDING TO FSA') {
        status = 'Not Proceeding To Fsa';
      }
      else if (value == 'NOT PROCEEDING FSA') {
        status = 'Not Proceeding To Contract';
      }
      else if (value == 'NOT PROCEEDING TO CONTRACT') {
        status = 'Not Proceeding To Contract';
      }
      else if (value == 'LOST') {
        status = 'Lost';
      }
      else if (value == 'TURNED DOWN') {
        status = 'Turned Down';
      }

      // return <Tag value={status} className='p-2' severity={getSeverity(status)} />;
      return <Tag value={status} className='p-2' style={{ backgroundColor: getSeverity(status), color: 'white' }} />;
    }
  };


  const projectStatusItemTemplate = (option) => {
    let x = option;
    if (option == 'Warranty') {
      x = 'Warranty complete'
    }
    if (option == 'Complete') {
      x = 'Construction complete'
    }
    if (option == 'FSA Active') {
      x = 'FSA Construction'
    }

    return <Tag value={x} className='p-2' style={{ backgroundColor: getColorForStatus(option), color: 'white' }} />;
  };



  const getStatus = (rowData) => {
    var status = rowData.new_status;

    let x = status;
    if (status == 'Warranty') {
      x = 'Warranty complete'
    }
    if (status == 'Complete') {
      x = 'Construction complete'
    }
    if (status == 'FSA Active') {
      x = 'FSA Construction'
    }

    // return <Tag value={status} className='p-2' style={{ backgroundColor: getColorForStatus(status), color: 'white' }} />;
    return <Tag value={x} className='p-2' style={{ backgroundColor: getColorForStatus(status), color: 'white' }} />;
  };

  const getColorForStatus = (status) => {
    switch (status) {
      case 'Opportunity':
        return '#FFC107';

      case 'Lead Closed':
        return '#003366';

      case 'Lead Lost':
        return '#A9A9A9';

      case 'Lead Hold':
        return '#FFA500';

      case 'Lead Turned Down':
        return '#4F4F4F';

      case 'FSA Development':
        return '#87CEEB';

      case 'FSA Construction':
        return '#228B22';
      case 'FSA Active':
        return '#228B22';

      case 'FSA Hold':
        return '#556B2F';

      case 'FSA Cancelled':
        return '#8B0000';

      case 'Contract Active':
        return '#2E8B57';

      case 'Contract Hold':
        return '#D4AF37';

      case 'Contract Cancelled':
        return '#DC143C';

      case 'Construction Start':
        return '#FFA500';


      case 'Construction Complete':
        return '#4682B4';

      case 'Warranty Complete':
        return '#708090';


      default:
        return '#00AC47';
    }
  };

  const projectTypes = ['Renovation', 'Custom Home', 'Garden Suite', 'House Lift', 'Small Reno(Kitchen/Bath)', 'Multi Family', 'Developement', 'Commercial', 'Interior Design Only', 'Tenant Improvements'];

  const getSeverity = (status) => {
    switch (status) {
      case 'Renovation':
        return '#556B2F';

      case 'Custom Home':
        return '#008080';

      case 'Garden Suite':
        return '#008080';

      case 'House Lift':
        return '#556B2F';

      case 'Small Reno(Kitchen/Bath)':
        return '#556B2F';

      case 'Multi Family':
        return '#DC143C';

      case 'Developement':
        return '#FFC107';

      case 'Commercial':
        return '#003366';

      case 'Interior Design Only':
        return '#FF7F50';

      case 'Tenant Improvements':
        return '#228B22';

      case 'ACTIVE':
        return 'success';

      case 'Active':
        return 'success';

      case 'TURNED DOWN':
        return 'secondary';

      case 'Turend Down':
        return 'secondary';

      case 'LOST':
        return 'danger';

      case 'Lost':
        return 'danger';

      case 'NOT PROCEEDING TO FSA':
        return 'warning';

      case 'Not Proceeding To Fsa':
        return 'warning';

      case 'NOT PROCEEDING TO CONTRACT':
        return 'primary';

      default:
        return 'success';

    }
  };

  const projectTypeRowFilterTemplate = (field, options) => {
    return (
      <Dropdown value={selectedColumnField == field ? selectedColumnValue : null} options={options} onChange={(e) => {

        console.log(e.value)
        setSelectedColumnValue(e.value)
        setSelectedColumnField(field)
        onSearchFetchDataForFilterTemplate(e.value, field)
      }
      } itemTemplate={statusItemTemplate} placeholder="Select One" className="p-column-filter" showClear style={{ minWidth: '12rem' }} />
    );
  };

  const projectStatusRowFilterTemplate = (options) => {
    var status_items = ['Opportunity', 'Lead Closed', 'Lead Lost', 'Lead Hold', 'Lead Turned Down', 'FSA Development', 'FSA Construction', 'FSA Hold', 'FSA Cancelled', 'Contract Active', 'Contract Hold', 'Contract Cancelled', 'Construction Start', 'Construction Complete', 'Warranty Complete']

    return (
      <Dropdown value={selectedColumnField === 'new_status' ? selectedColumnValue : null} options={status_items} onChange={(e) => {

        setSelectedColumnStatusValue(e.value)
        localStorage.setItem('selectedColumnStatusValue', e.value);

        setSelectedColumnField('new_status')
        if (e.value === undefined) {
          setSelectedColumnStatusValue('All')
          localStorage.setItem('selectedColumnStatusValue', 'All');
        }

        console.log(e.value)

        onSearchFetchDataForFilterTemplate(e.value, 'new_status')
      }
      }

        itemTemplate={projectStatusItemTemplate} placeholder="Select One" className="p-column-filter" showClear style={{ minWidth: '12rem' }} />
    );
  };

  const onSearchFetchDataForFilterTemplate = async (searchValue, field) => {
    var status_value = localStorage.getItem('selectedColumnStatusValue');

    setSelectedColumnValue(searchValue)
    setSelectedColumnField(field)
    setFirst(0);

    setLoading(true);

    var params = {
      start: 0,
      length: rows,
      // search: field == 'new_status' ? null : searchValue,
      search: searchValue,
      order: '',
      orderDir: 'DESC',

      status: status_value,
      field: field

    };

    var url = Api.API_BASE_URL + 'leads-tracker/all-leads-server-side'; //leads-datatable-server-side';

    try {
      const token = localStorage.getItem('authToken');

      // Create headers with token if it exists
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
      };
      console.log('API Call 3', params);
      const response = await axios.get(url, { params: params, headers: headers });
      setLeads(response.data.data);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      console.error('Error fetching data', error);
    }

    setLoading(false);
  };

  const onSearchFilterData = async (searchValue, field) => {
    setSelectedColumnValue(searchValue)
    setSelectedColumnField(field)
    setFirst(0);

    setLoading(true);

    var params = {
      start: 0,
      length: rows,
      search: field == 'new_status' ? null : searchValue,
      order: '',
      orderDir: 'DESC',
      field: field
    };

    var url = Api.API_BASE_URL + 'leads-tracker/all-leads-server-side';

    try {
      const token = localStorage.getItem('authToken');

      // Create headers with token if it exists
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
      };
      console.log('API Call 4', params);
      const response = await axios.get(url, { params: params, headers: headers });
      setLeads(response.data.data);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      console.error('Error fetching data', error);
    }

    setLoading(false);
  };

  const statusRowFilterTemplateSerach = (field) => {
    return (
      <span className="p-input-icon-left flex align-items-center justify-content-end ">
        <InputText
          className="input-field m-2"
          style={{ minWidth: '12rem' }}
          type="search"
          value={selectedColumnField === field ? selectedColumnValue : ''}
          onChange={(e) => onSearchFilterData(e.target.value, field)}
          placeholder="Search" />
      </span>
    );
  };

  //* -------------------
  const capitalizeFirstLetter = (str) => {
    if (!str) return str; // Check for empty string
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };


  // const statuses = ['ACTIVE', 'TURNED DOWN', 'LOST', 'NOT PROCEEDING TO FSA', 'NOT PROCEEDING TO CONTRACT'];
  const statuses = ['Opportunity', 'Lead Closed', 'Lead Lost', 'Lead Hold', 'Lead Turned Down', 'FSA Active', 'FSA Hold', 'FSA Cancelled', 'Contract Active', 'Contract Hold', 'Contract Cancelled', 'Construction Start', 'Construction Complete', 'Warranty Complete'];


  const capitalizedStatuses = statuses.map(status => capitalizeFirstLetter(status));
  //! -------------------


  const getDataTable = () => {
    return (
      <DataTable
        value={leads}
        lazy
        paginator
        rows={rows}
        first={first}
        totalRecords={totalRecords}
        loading={loading}
        onPage={fetchData}
        onSort={fetchData}
        //onFilter={fetchData}
        filters={filters}
        globalFilterFields={['client', 'email', 'address', 'assignee', 'contact_date', 'project_type', 'project_value']}
        sortField={sortField}
        sortOrder={sortOrder}
        filterDisplay="row"
        // rowClassName={rowClass}
        dataKey="_id"
        showHeaders
        // tableStyle={{ minWidth: '50rem', minHeight: '56px' }}
        scrollable
        scrollHeight="69vh"
        stripedRows
        size="small"

        selectionMode="single"
        selection={selectedProduct}
        onRowSelect={onRowSelect}
        onRowUnselect={onRowUnselect}
        onSelectionChange={(e) => setSelectedProduct(e.value)}

        rowsPerPageOptions={[20, 50, 100, 250]}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Leads   "
      >

        <Column frozen body={actionBodyTemplate} header="Action" style={{ textAlign: 'center', minWidth: '100px', minHeight: '50px', }} exportable={false} ></Column>

        <Column field="internal_job" header="Internal " frozen body={(e) => e.internal_job === 'Y' ? '✅' : ''} style={{ minWidth: '2rem', textAlign: 'center', }} ></Column>

        <Column frozen field="new_status" header="status" sortable style={{ minWidth: '100px', height: '50px', textAlign: 'center' }} body={getStatus} filter filterElement={projectStatusRowFilterTemplate} showFilterMenu={false}></Column>

        <Column field="client" header="Client" sortable style={{ width: '100px', height: '50px', }} filter filterElement={() => statusRowFilterTemplateSerach('client')} showFilterMenu={false} ></Column>

        <Column field='contact_date' header="contact date" style={{ minWidth: '200px', height: '50px', textAlign: 'center' }} sortable body={(e) => dateView(e.contact_date)} ></Column>

        <Column field="lead_source" header="Lead Source" sortable style={{ minWidth: '100px', height: '50px', textAlign: 'center' }} filter filterElement={() => statusRowFilterTemplateSerach('lead_source')} showFilterMenu={false}></Column>

        <Column field="address" header="Address" sortable style={{ minWidth: '100px', height: '50px' }} filter filterElement={() => statusRowFilterTemplateSerach('address')} showFilterMenu={false} body={(rowData) => (
          <>
            {rowData.address === "null null" ? "" : rowData.address}
          </>
        )}></Column>

        <Column field="assignee" header="Assignee" sortable style={{ minWidth: '100px', height: '50px' }} filter filterElement={() => statusRowFilterTemplateSerach('assignee')} body={(e) => projectTypeAssignee(e.assignee)} showFilterMenu={false}></Column>

        <Column field="email" header="email" sortable style={{ minWidth: '100px', height: '50px' }} body={emailBodyTemplate} filter filterElement={() => statusRowFilterTemplateSerach('email')} showFilterMenu={false} ></Column>

        <Column field="phone_number" header="phone number" sortable style={{ minWidth: '100px', height: '50px' }} filter filterElement={() => statusRowFilterTemplateSerach('phone_number')} showFilterMenu={false}></Column>

        <Column field="project_type" header="project type" sortable style={{ minWidth: '100px', height: '50px', textAlign: 'center' }} body={(e) => projectTypeBodyTemplateA(e.project_type)} filter filterElement={() => projectTypeRowFilterTemplate('project_type', projectTypes)} showFilterMenu={false} ></Column>

        <Column field="project_value" header="project value" sortable style={{ minWidth: '100px', height: '50px', textAlign: 'center' }} body={(data) => formatCurrency(data.project_value)} filter filterElement={() => statusRowFilterTemplateSerach('project_value')} showFilterMenu={false}></Column>

      </DataTable>
    )
  }

  const closeLeadModel = () => {
    console.log("close test ")
    setIsModalOpen(false);
  }

  const handleDataRefreshLeadModel = () => {
    setIsModalOpen(false);
    console.log('Data refreshed!');
    getListData();
  };

  const fetchData = async (event) => {
    const { first, rows, sortField, sortOrder } = event;
    setFirst(first);
    setRows(rows);
    setSortField(sortField);
    setSortOrder(sortOrder);

    setLoading(true);

    console.log('sort order: ', event);

    var params = {
      start: first,
      length: rows,
      search: selectedColumnField == 'new_status' ? null : selectedColumnValue,
      order: sortField,

      orderDir: sortOrder === 1 ? 'ASC' : 'DESC',
      status: selectedColumnStatusValue,
      field: selectedColumnField,
    };

    var url = Api.API_BASE_URL + 'leads-tracker/all-leads-server-side'; //leads-datatable-server-side';

    try {
      const token = localStorage.getItem('authToken');

      // Create headers with token if it exists
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
      };
      console.log('API Call 5', params);
      const response = await axios.get(url, { params: params, headers: headers });
      setLeads(response.data.data);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      console.error('Error fetching data', error);
    }
    setLoading(false);
  };

  const onSearchFetchData = async (searchValue) => {
    setGlobalFilter(searchValue);
    setFirst(0);
    setLoading(true);

    var params = {
      start: 0,
      length: rows,
      search: searchValue,
      order: sortField,
      orderDir: sortOrder === 1 ? 'ASC' : 'DESC',

      field: 'global',
    };

    var url = Api.API_BASE_URL + 'leads-tracker/all-leads-server-side';

    try {
      const token = localStorage.getItem('authToken');

      // Create headers with token if it exists
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
      };
      console.log('API Call 6', params);
      const response = await axios.get(url, { params: params, headers: headers });

      console.log(response.data.data);

      setLeads(response.data.data);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      console.error('Error fetching data', error);
    }

    setLoading(false);
  };

  const renderHeader = () => {
    return (
      <span className="p-input-icon-left flex align-items-center justify-content-end ">
        <InputText
          className="input-field m-2"
          style={{ width: '300px' }}
          type="search" value={globalFilter || ''}
          onChange={(e) => onSearchFetchData(e.target.value)}
          placeholder="Search" />
      </span>
    );
  };
  //! ----------------------
  //* ----------------------
  const [excelFile, setExcelFile] = useState(null);

  const [typeError, setTypeError] = useState(null);
  const [selectedExcelFile, setSelectedExcelFile] = useState();

  const [excelUploadModal, setExcelUploadModal] = useState(false)
  const [isRelplace, setIsRelplace] = useState('N');
  const [isRelplaceMessage, setIsRelplaceMessage] = useState("null");
  const [isReplaceConfirmationModalOpen, setIsReplaceConfirmationModalOpen] = useState(false);

  const openExcelUploadModal = () => {
    setExcelUploadModal(true);
  };

  const handleFile = (e) => {
    let fileTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'];
    let selectedFile = e.target.files[0];

    setSelectedExcelFile(selectedFile)
    if (selectedFile) {
      if (selectedFile && fileTypes.includes(selectedFile.type)) {
        setTypeError(null);
        let reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile);
        reader.onload = (e) => {
          setExcelFile(e.target.result);
        }
      }
      else {
        setTypeError('Please select only excel file types');
        setExcelFile(null);
      }
    }
    else {
      console.log('Please select your file');
    }
  }

  const handleFileSubmit = async (e) => {
    e.preventDefault();
    // start Loader

    if (excelFile !== null) {
      setIsFormSubmitLoadder(true)

      const formData = new FormData();


      formData.append("userId", localStorage.getItem('user_id'));
      formData.append("roleId", localStorage.getItem('role_id'));
      formData.append("isRelplace", isRelplace);
      // formData.append("excel_file", selectedExcelFile);
      formData.append("lead_file", selectedExcelFile);

      const token = localStorage.getItem('authToken');

      // Create headers with token if it exists
      const headers = {
        // 'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
      };

      fetch(Api.API_BASE_URL + 'crm/lead-import', {
        method: "POST",
        headers: headers,
        body: formData,

      })
        .then((response) => response.json())
        .then((Josn) => {
          setIsFormSubmitLoadder(false)
          if (Josn.error !== '') {

            // End Loader

            toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });


          } else {
            // End Loader
            toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
            // setIsFormSubmitLoadder(false)       
            setExcelUploadModal(false)
            setIsReplaceConfirmationModalOpen(false)

            setExcelFile(null);
            getListData()


          }

        })
        .catch((error) => {
          console.error("Error:", error);
        });// You can adjust this as needed



    }
  };
  //! ----------------------


  return (
    <>
      <Toast ref={toast} />
      {isLoading ? (
        <div className="loading-spinner">
          Loading...
          <div className="spinner"></div>
        </div>
      ) : (
        <div className="leads-pagination-datatable">
          <div className='flex align-items-center justify-content-between'>
            <div className='col flex p-0'>
              <button type="button" title='Download leads data in excel' style={{ cursor: 'pointer' }} onClick={exportExcel} data-pr-tooltip="XLS" outlined className="exce-download-button my-2" >
                <div className='flex items-center gap-2'>
                  <FaFileExcel size={14} />
                  <span> Download Excel </span>
                </div>
              </button>
            </div>

            <div className='flex'>
              <button type="button" title='Add new Leads' style={{ cursor: 'pointer' }} onClick={addLeads} className="custom-button m-2 ml-0" >
                <div className='flex items-center gap-2 px-1 '>
                  <BiPlusMedical size={14} />
                  <span> Add </span>
                </div>
              </button>
            </div>

          </div>
          {/* // ------------------------------------------- */}
          <div className='flex align-items-center justify-content-between'>
            <div className='col flex p-0'>
              <button type="button" title='Download leads data in excel' style={{ cursor: 'pointer', width: '162px' }} onClick={openExcelUploadModal} data-pr-tooltip="XLS" outlined className="exce-upload-button my-2" >
                <div className='flex items-center gap-2'>
                  <FaFileExcel size={14} />
                  <span> Upload Excel </span>
                </div>
              </button>
            </div>

            <div className='flex'>
              <div>
                {renderHeader()}
              </div>
            </div>
          </div>
          {getDataTable()}
        </div>)}
      {/* // ----------------upload Excel------------------------------ */}
      <Dialog header="Upload Excel File" visible={excelUploadModal} maximizable style={{ width: '40vw' }}
        onHide={() => {
          setExcelUploadModal(false);
          setIsFormSubmitLoadder(false);
        }}
      >

        <div className='p-2'>
          <form onSubmit={handleFileSubmit} >

            <div className="flex-col px-3 mt-4">

              <input type="file" className='uploadfile w-full' required onChange={handleFile} />
              <div className="w-full flex mt-5" style={{ justifyContent: 'center' }}>
                {isFormSubmitLoadder ? (
                  <button type='button' className='customSave-button '>   <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" animationDuration=".5s" /></button>
                ) : (<button type='submit' className='customSave-button '> SUBMIT </button>)}
              </div>


            </div>

          </form>


          {typeError && (
            <div style={{ color: "red", display: "block", textAlign: 'center', fontSize: '2rem', fontWeight: 'bold' }}>
              {typeError}
            </div>
          )}


        </div>

      </Dialog>

      {isReplaceConfirmationModalOpen && (
        <div className="modal">
          <div className="small-modal-content">
            <div className="modal-headerx">
              <h5 className="modal-title">Confirmation</h5>
              <button className="modal-closex"
                // onClick={(e) => setIsReplaceConfirmationModalOpen(false)}
                onClick={(e) => {
                  setIsReplaceConfirmationModalOpen(false)
                }}
              >
                &times;
              </button>
            </div>
            <div className="modal-bodyx">
              <p>{isRelplaceMessage}</p>
            </div>
            <div className="modal-footer-cancelx">
              <button className="cancel-buttonx" title='No' onClick={(e) => setIsReplaceConfirmationModalOpen(false)}>
                No
              </button>

              {isFormSubmitLoadder ? (
                <button className='delete-buttonx' title='Delete' >   <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" animationDuration=".5s" /></button>
              ) : (<button className="delete-buttonx" style={{ background: 'green' }} onClick={handleFileSubmit}>
                Yes
              </button>)}



            </div>
          </div>
        </div>
      )}

      {/* // ----------------upload Excel------------------------------ */}
      {/* //* ----------------Email dialog Box Start------------------------------ */}
      <Dialog header={`Send an Email to - ${showName}`} visible={emailPopUp} style={{ width: '40vw' }} dismissableMask={true} onHide={() => setEmailPopUp(false)}>
        <div className="p-2">
          <form onSubmit={handleSaveSubmit} className="">
            <div className="px-2">
              <div className='col-12 pt-2'>
                <label htmlFor="to">
                  To : <strong> {showName} </strong>

                </label>
              </div>

              <div className='col-12 pt-2 multee'>

                {ccDropdowng()}
              </div>
              <div style={{ marginLeft: '8px' }}>CC:</div>
              {
                selectedCCList.map((item, index) =>

                (
                  <div style={{ fontWeight: '600', marginLeft: '38px', paddingBottom: '8px', fontSize: '14px' }} > * {item.first_name + ' ' + item.last_name + ' (' + item.role_name + ')'} </div>)
                )
              }

              <div className='col-12 pt-2'>
                <label htmlFor="customSubject">Subject</label>
                <InputText
                  id="customSubject"
                  value={customSubject}
                  onChange={(e) => setCustomSubject(e.target.value)}
                  className="p-inputtext p-component p-2"
                  style={{ width: '100%', marginTop: '10px' }}
                />
              </div>
              <div className="col-12 pt-2">
                <label htmlFor="customMessage" className='pb-10'>Message</label>
                <Editor
                  id="customMessage"
                  value={customMessage}
                  onTextChange={(e) => setCustomMessage(e.htmlValue)}
                  style={{ height: '220px' }} />
              </div>
              <div className="flex gap-4 flex-wrap justify-content-center mt-4">
                <Button label="Cancel" type="button" className="p-2 px-3 copySave-button" severity="warning" onClick={() => setEmailPopUp(false)} />
                <Button label="Send" type="submit" className="p-2 px-3 customSave-button" severity="success" />
              </div>
            </div>
          </form>
        </div>
      </Dialog>
      {/* //! ----------------Emaildialog Box End------------------------------ */}
      {/* // ----------------dialog Box------------------------------ */}
      {isModalOpen && <LeadModel lead={editLeadList} onClose={closeLeadModel} onDataRefresh={handleDataRefreshLeadModel} />}
      {/* // ----------------Delete-Modals--------------------------------- */}

      {isDeleteConfirmationModalOpen && (
        <div className="modal">
          <div className="small-modal-content">
            <div className="modal-headerx">
              <h5 className="modal-title">Delete Confirmation</h5>
              <button className="modal-closex" onClick={closeModal}>
                &times;
              </button>
            </div>
            <div className="modal-bodyx">
              <p>{projectDeletetitle}</p>
            </div>
            <div className="modal-footer-cancelx">
              <button className="cancel-buttonx" title='Cancel' onClick={closeModal}>
                Cancel
              </button>
              <button className="delete-buttonx" title='Delete' onClick={confirmDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* --------------------Color Plate-Modals---------------------- */}

      <Dialog header="" visible={colorPlatedailog} maximizable style={{ width: '500px' }} dismissableMask="true" onHide={() => setColorPlatedailog(false)}>
        <div className='card'>
          {CommonService.getColorDeclarationComponent()}
        </div>
      </Dialog>




    </>
  )
}

export default Leads
